import * as React from 'react';
import './message.less';

// [COMPONENT USAGE]
/* <Message
	title="Operation Message"
	subTittle="Some words to describe this operation message"
	type="success"
	description="Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type"
></Message>; */

export interface MessageProps {
	/** sets the type of the message */
	type?: 'success' | 'error' | 'warning';
	/** sets the title of the message*/
	title?: string;
	/** sets the subTittle of the message*/
	subTittle?: string;
	/** sets the description of the message*/
	description?: string;
}

export const Message = (props: MessageProps): JSX.Element => {
	const { title, subTittle, description, type } = props;
	return (
		<>
			<div className={`ds-message ds-message-${type}`}>
				<div className="ds-message-content">
					<span className="ds-heading3-regular">{title}</span>
					<span className="ds-heading5-regular">{subTittle}</span>
					{description && (
						<div className="ds-message-description">
							<span className="ds-large-text-regular">{description}</span>
						</div>
					)}
				</div>
			</div>
		</>
	);
};
